module.exports = __webpack_public_path__ + "static/media/portfolios.db7f2807.svg";